export default {
	INGREDIENT_CONFIGURATIONS_TABLE_TITLE: 'Ingredient Configurations',
	INGREDIENT_CONFIGURATION_ADDED: 'Ingredient configuration added!',
	INGREDIENT_CONFIGURATION_EDITED: 'Ingredient configuration edited!',
	INGREDIENT_CONFIGURATION_DELETED: 'Ingredient configuration deleted!',
	INGREDIENT_CONFIGURATION_MODAL_HEADER_NAME: 'Ingredient configuration name',
	INGREDIENT_CONFIGURATION_MODAL_HEADER_LEGACY: 'Legacy'
};
